// Fonction pour associer les items avec la base de données
const associateItemWithDatabase = (database, itemName) => {
    // Objet pour stocker les informations mappées
    let itemInfoMap = {};

    // Parcourir les données de la première API pour remplir le mappage
    database.forEach(category => {
        category.subcategories.forEach(subcategory => {
            // Déterminer quelle liste est présente dans la sous-catégorie
            const lists = Object.values(subcategory).find(value => Array.isArray(value) && value.length > 0 && value[0].id !== undefined);

            // Si une liste existe
            if (lists) {
                // Parcourir les items de la liste pour trouver une correspondance avec itemName
                lists.forEach(item => {
                    if (item.name === itemName) {
                        // Si une correspondance est trouvée, remplir l'itemInfoMap avec les données
                        itemInfoMap = {
                            backgroundColor: category.backgroundColor,
                            category: category.name,
                            subcategory: subcategory.name,
                            impactMoney: item.impact[0].money,
                            impactCO2: item.impact[0].CO2,
                            impactTrash: item.impact[0].trash,
                        };
                    }
                });
            }
        });
    });

    return itemInfoMap;
};

export default associateItemWithDatabase;
